import { render } from "./BookingPage.vue?vue&type=template&id=20fed648"
import script from "./BookingPage.vue?vue&type=script&lang=js"
export * from "./BookingPage.vue?vue&type=script&lang=js"

import "./BookingPage.vue?vue&type=style&index=0&id=20fed648&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__